import { padding } from '@mui/system';
import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';

class WorkflowStartSelect extends Component {

    constructor(props)
    {
        super(props)
    }

    state = {
        appType: ""
    }

    render() {
        const { t } = this.props;

        return this.props.isLegacy? (

            <div className="p-2" onClick={this.props.onClick} style={{border:"1px solid #E6E6E6", borderRadius:"10px", padding:"40px", margin:"40px", cursor:"pointer"}}>
                <table width="300" style={{height:"100%"}}>
                    <tbody>
                        <tr>
                            <td width="84" valign="middle" align="center">
                                <div>
                                    <i className={this.props.iconClassName} aria-hidden="true" style={{ fontSize: "36px", color: "#d01a62" }}></i>
                                </div>
                            </td>
                            <td className="large-icon-div">
                                <b>{this.props.title}</b>
                                <br />
                                {this.props.text}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        ) : (
            <div onClick={this.props.onClick} style={{border:"1px solid #E6E6E6", borderRadius:"10px", padding:"20px", margin:"auto", cursor:"pointer"}}>
                <table width="300" style={{height:"100%"}}>
                    <tbody>
                        <tr>
                            <td width="84" valign="middle" align="center">
                                <div>
                                    <i className={this.props.iconClassName} aria-hidden="true" style={{ fontSize: "36px", color: "#d01a62" }}></i>
                                </div>
                            </td>
                            <td className="large-icon-div">
                                <b>{this.props.title}</b>
                                <br />
                                {this.props.text}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

export default withTranslation()(WorkflowStartSelect)